import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconArrowHead } from '../../components';

const ShowMoreChildren = ({ children, lines, anchorClass, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const flatChildren = React.Children.toArray(children).flat();
  const filteredChildren = flatChildren.filter(Boolean);
  const shouldRenderShowMore = filteredChildren.length >= lines;
  const childrenFinal =
    !isExpanded && !!lines ? filteredChildren.slice(0, lines) : filteredChildren;
  return (
    <div className={className}>
      {childrenFinal}
      {shouldRenderShowMore && (
        <span onClick={() => setIsExpanded(prev => !prev)} className={anchorClass}>
          {isExpanded ? (
            <>
              <FormattedMessage id="Global.showLess" />
              <IconArrowHead direction="up" />
            </>
          ) : (
            <>
              <FormattedMessage id="Global.showMore" />
              <IconArrowHead direction="down" />
            </>
          )}
        </span>
      )}
    </div>
  );
};

export default ShowMoreChildren;
